import React from 'react';
import { formatInr, formatUsdDisplay, getPricePresentation } from '../../utils/pricing';
import { useEarlyAccessListener } from '../../utils/earlyAccess';
import './PriceDisplay.css';

/**
 * Shows ₹original (strike) · ₹current ($usd) and optional savings line.
 */
const PriceDisplay = ({ className = '', showSaved = true, compact = false }) => {
  useEarlyAccessListener();
  const p = getPricePresentation();

  return (
    <div
      className={`price-display ${p.earlyAccess ? 'price-display--early' : ''} ${compact ? 'price-display--compact' : ''} ${className}`.trim()}
    >
      <div className="price-display-row">
        <span className="price-display-original">{formatInr(p.originalInr)}</span>
        <span className="price-display-current">
          {formatInr(p.currentInr)}{' '}
          <span className="price-display-usd">({formatUsdDisplay(p.usd)})</span>
        </span>
      </div>
      {p.earlyAccess && (
        <span className="price-display-badge price-display-badge--early">Early access</span>
      )}
      {showSaved && p.savedInr > 0 && (
        <p className="price-display-saved">{p.savedLabel}</p>
      )}
    </div>
  );
};

export default PriceDisplay;
